import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http';
import { catchError, map, Observable, throwError } from 'rxjs';
import { LocalStorageService } from 'src/app/core/services/local/local-storage.service';
import { AuthService } from 'src/app/core/services/api/auth.service';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {

  private AUTH_HEADER = 'Authorization';

  constructor(
    private localStorage: LocalStorageService,
    private authService: AuthService
  ) { }

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // si se pide token se retorna el request de una vez
    if (req.url.includes('token')) {
      req = req.clone({
        headers: req.headers.set('Content-Type', 'application/x-www-form-urlencoded')
      });

      return next.handle(req);
      // return next.handle(req);
    }

    // se agrega el content type 'application/json' al request
    if (!req.headers.has('Content-Type')) {
      // if (!req.url.includes('api/Company/EditCompanyConfig')) {
      //   req = req.clone({
      //     headers: req.headers.set('Content-Type', 'application/json')
      //   });
      // }
      req = req.clone({
        headers: req.headers.set('Content-Type', 'application/json')
      });
    }

    // se verifica que use autenticacion y de ser asi se evalua su estado y se agrega
    req = this.addAuthenticationToken(req);

    return next.handle(req).pipe(map((event: HttpEvent<any>) => {
      return event;
    }),
      catchError((error: HttpErrorResponse) => {
        const started = Date.now();
        const elapsed = Date.now() - started;
        console.log(`Request for ${req.urlWithParams} failed after ${elapsed} ms.`);
        return throwError(error);
      })
    );

  }

  private addAuthenticationToken(request: HttpRequest<any>): HttpRequest<any> {
    // If we do not have a token yet then we should not set the header.
    // Here we could first retrieve the token from where we store it.
    const TOKEN = this.localStorage.GetItem('currentUserIcemInv');
    if (!TOKEN) {
      return request;
    }

    if (!this.authService.isAuthenticated()) {
      // this.authService.logoutForToken();
      this.authService.logout();
      //throw new Error('No esta autenticado');
      throwError(() => new Error('Token invalido'));
    }
    return request.clone({
      headers: request.headers.set(this.AUTH_HEADER, `Bearer ${TOKEN.access_token}`)
    });
  }

}